import { render, staticRenderFns } from "./RadioCatalogItem.vue?vue&type=template&id=1bb86255"
import script from "./RadioCatalogItem.vue?vue&type=script&lang=js"
export * from "./RadioCatalogItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports